import React from "react";
import Input from "@/common/components/custom/Input";
import SelectInput from "@/common/components/custom/SelectInput";
import CustomEditButton from "@/common/components/custom/buttons/CustomEditButton";
import { ButtonWrapper } from "../../../AdminCommandPage.styled";
import VoiceConfigTable from "../../../../languages/components/VoiceConfigTable";
import { LANGUAGE_MODE } from "../constants";
import { ChoiceRow, Hint } from "../AddLanguageWizard.styled";

const StepAddLanguage = ({
  languageMode,
  setLanguageMode,
  languagesOptions,
  selectedExisting,
  setSelectedExisting,
  nameRef,
  shortNameRef,
  isLangToRef,
  voices,
  setVoices,
  handleStepOneBack,
  handleCreateLanguage,
}) => (
  <form onSubmit={handleCreateLanguage}>
    {!languageMode && (
      <>
        <Hint>Create a new language or pick an existing one.</Hint>
        <ChoiceRow>
          <CustomEditButton
            text="Create language"
            onClick={() => setLanguageMode(LANGUAGE_MODE.CREATE)}
          />
          <CustomEditButton
            text="Select language"
            onClick={() => setLanguageMode(LANGUAGE_MODE.SELECT)}
          />
        </ChoiceRow>
        <ButtonWrapper>
          <CustomEditButton text="Back" onClick={handleStepOneBack} />
        </ButtonWrapper>
      </>
    )}
    {languageMode === LANGUAGE_MODE.SELECT && (
      <>
        <Hint>Continue with an existing language.</Hint>
        <SelectInput
          width={180}
          selectWidth={260}
          name="Language"
          options={languagesOptions}
          selected={selectedExisting}
          setSelected={setSelectedExisting}
        />
        <ButtonWrapper>
          <CustomEditButton text="Back" onClick={handleStepOneBack} />
          <CustomEditButton text="Continue" onClick={handleCreateLanguage} />
        </ButtonWrapper>
      </>
    )}
    {languageMode === LANGUAGE_MODE.CREATE && (
      <>
        <Hint>Fill language data and add a voice if needed.</Hint>
        <Input inputRef={nameRef} name="Name" width={180} required />
        <Input
          inputRef={shortNameRef}
          name="Short name"
          width={180}
          required
          placeholder="el"
        />
        <Input
          inputRef={isLangToRef}
          name="Is lang to"
          width={180}
          type="checkbox"
          checked
        />
        <VoiceConfigTable voices={voices} setVoices={setVoices} />
        <ButtonWrapper>
          <CustomEditButton text="Back" onClick={handleStepOneBack} />
          <CustomEditButton
            text="Create language"
            onClick={handleCreateLanguage}
          />
        </ButtonWrapper>
      </>
    )}
  </form>
);

export default StepAddLanguage;
